import { render, staticRenderFns } from "./MessageTemplateBox.vue?vue&type=template&id=49168820&scoped=true"
import script from "./MessageTemplateBox.vue?vue&type=script&lang=js"
export * from "./MessageTemplateBox.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplateBox.vue?vue&type=style&index=0&id=49168820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49168820",
  null
  
)

export default component.exports